<template>
<div class="lsinenrmmt">
    <v-refresh :on-refresh="onRefreshone">
      <v-reload
        :on-infinite-load="infinite"
        :parent-pull-up-state="infiniteLoadData.pullUpState"
      >
        <div v-if="list.length>0" class="lisctennr">
          <div v-for="(item,index) in list" :key="index" class="listitem" >
              <p class="bus">
                <span style="margin-right: 0.3em">{{item.businessReasonStr}}</span>
                <md-tag v-if="item.examineStatus === 0" size="large" shape="fillet" fill-color="#FF8843" font-weight="normal" font-color="white" type="fill">待审核</md-tag>
                <md-tag v-if="item.examineStatus === 2" size="large" shape="fillet" fill-color="red" font-weight="normal" font-color="white"  type="fill">审核驳回</md-tag>
                <md-tag v-if="item.examineStatus === 1" size="large" shape="fillet" fill-color="#28AA91" font-weight="normal" font-color="white"  type="fill">审核通过</md-tag>
              </p>
              <p class="mony">
               	<span style="color: orangered;" v-if="item.type === 1">+{{item.money/100}}</span>
			          	<span v-else>-{{item.money/100}}</span>
              </p>
              <p class="time">{{item.createTime| dateformat('YYYY-MM-DD HH:mm')}}</p>
              <p class="time" v-if="item.examineStatus === 2">驳回原因: {{ item.remarks }}</p>
           </div>

        </div>
        <noth-modal v-else></noth-modal>
        <div style="width: 100%;height: 2rem"></div>
      </v-reload>
    </v-refresh>

</div>
</template>
<script>
import DropDownRefresh from '../../components/refresh'
import PullUpReload from '../../components/pullDown'
import NothModal from '../Modal/NothModal'
import {
  Toast,
  Tag
} from "mand-mobile";

export default {
  name: "ListDetail",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    'v-refresh': DropDownRefresh,
    // eslint-disable-next-line vue/no-unused-components
    'v-reload': PullUpReload,
    // eslint-disable-next-line vue/no-unused-components
    NothModal,
    [Tag.name]: Tag,
  },
  data () {
    return {
      list:[],
       infiniteLoadData: {
        initialShowNum: 20, // 初始显示多少条
        everyLoadingNum: 20, // 每次加载的个数
        pullUpState: 4, // 子组件的pullUpState状态
        pullUpList: [], // 上拉加载更多数据的数组
        showPullUpListLength: this.initialShowNum // 上拉加载后所展示的个数
      },
      pagenum: 1,
    };
  },
activated() {
  this.getlist(null)
},
methods: {
   onRefreshone (done) {
      setTimeout(() => {
        this.infiniteLoadData.pullUpList = []
        this.pagenum = 1
        this.getlist(null)
        done()
      }, 500)
    },
     infinite (done) {
      console.log(this.infiniteLoadData.pullUpState)
      if (this.infiniteLoadData.pullUpState === 1) {
        setTimeout(() => {
          this.pagenum++
          this.getlist('load')
          done()
        }, 500)
      } else {
        done()
        this.infiniteLoadData.pullUpState = 0
      }
    },
     getlist (opear) {
      this.infiniteLoadData.pullUpState = 2
      const par = {
        pageNum: this.pagenum,
        pageSize: 20,
      }
       this.ajax
        .AJAx(this.ports.accountrecord, 'post', par).then(res => {
        if (opear) {
          if (res.list.length > 0) {
            this.list = this.list.concat(res.list)
            this.infiniteLoadData.pullUpList = this.list
            if (res.list.length < 20) {
              this.infiniteLoadData.pullUpState = 3
            } else {
              this.infiniteLoadData.pullUpState = 1
            }
          } else {
            this.infiniteLoadData.pullUpState = 3
          }
        } else {
          if (res.list.length < 20) {
            this.infiniteLoadData.pullUpState = 3
          } else {
            this.infiniteLoadData.pullUpState = 1
          }
          this.list = res.list
          this.infiniteLoadData.pullUpList = this.list
        }
        this.list.length < 18 ? this.infiniteLoadData.pullUpState = 0 : null
        Toast.hide()
      }).catch(err => {
        Toast.hide()
      })
    },
},
}
</script>
<style lang="less" scoped>
.lisctennr{
  background-color: white;
  .listitem{
    width: 90%;
    margin-left: 5%;
    border-bottom: 1px solid #f2f2f2;
    .bus{
      text-align: left;
     padding-top: 0.2rem;
      font-size: 0.3rem;
    }
    .mony{
      text-align: left;
      font-size: 0.3rem;
      font-weight: 500;
      text-align: right;
    }
    .time{
      text-align: left;
      font-size: 0.3rem;
      padding-bottom: 0.2rem;
    }
  }
}
</style>
